import React from 'react';
import { Grid, Modal } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import { Button } from '@HomaHealth/ui-component-library/lib/_AIQ-components';

interface IdleWarningModalProps {
  open: boolean;
  remainingSeconds: number;
  onStayLoggedIn: () => void;
  onLogoutNow: () => void;
}

const useStyles = makeStyles()({
  root: {
    backgroundColor: patientAccessTheme.palette.status.white,
    borderRadius: '8px',
    padding: '24px 32px 20px 32px',
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '500px',

    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    justifyContent: 'center',
    alignItems: 'center',
  },
  countdown: {
    fontSize: '36px',
    fontWeight: 800,
    margin: '0 0 16px',
    letterSpacing: '-0.5px',
    transition: 'color 0.3s',
  },
  subText: {
    fontSize: '13px',
    color: '#9CA3AF',
    margin: '0 0 28px',
  },
  buttonRow: {
    display: 'flex',
    gap: '12px',
    justifyContent: 'center',
  },
  btnContainer: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
  },
});

const IdleWarningModal: React.FC<IdleWarningModalProps> = ({
  open,
  remainingSeconds,
  onStayLoggedIn,
  onLogoutNow,
}) => {
  const { classes } = useStyles();

  const minutes = Math.floor(remainingSeconds / 60);
  const seconds = remainingSeconds % 60;
  const timeDisplay =
    minutes > 0
      ? `${minutes}:${String(seconds).padStart(2, '0')} minutes`
      : `${seconds} second${seconds !== 1 ? 's' : ''}`;

  const isUrgent = remainingSeconds <= 30;

  return (
    <Modal open={open} style={{ outline: 'none' }}>
      <Grid container className={classes.root}>
        <Grid>
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="#F59E0B" strokeWidth="2" />
            <path
              d="M12 7v5l3 3"
              stroke="#F59E0B"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        </Grid>
        <Typography fontSize="20px" fontType="bold">
          Session Expiring Soon
        </Typography>
        <Typography fontSize="14px" align="center">
          You've been inactive for a while. For your security, you'll be
          automatically logged out in:
        </Typography>
        <Grid
          className={classes.countdown}
          style={{
            color: isUrgent ? '#EF4444' : '#1D4ED8',
          }}
        >
          {timeDisplay}
        </Grid>
        <Typography fontSize="14px" align="center">
          Click <strong>"Stay Logged In"</strong> to continue your session.
        </Typography>
        <Grid className={classes.btnContainer}>
          <Button
            label="Logout Now"
            width="190px"
            styleProps={{ textTransform: 'uppercase' }}
            onClick={onLogoutNow}
          />
          <Button
            variant="contained"
            label="Stay Logged In"
            width="190px"
            styleProps={{ textTransform: 'uppercase' }}
            onClick={onStayLoggedIn}
          />
        </Grid>
      </Grid>
    </Modal>
  );
};

export default IdleWarningModal;
